import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface DirectoryEntry {
  id: string
  name: string | null
  email: string
  loginid: string | null
  extension: string | null
  location: string | null
  branch: string | null
  department: string | null
  avatarUrl: string | null
}

export interface UseCompanyDirectoryResult {
  entries: DirectoryEntry[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useCompanyDirectory(): UseCompanyDirectoryResult {
  const [entries, setEntries] = useState<DirectoryEntry[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ entries: DirectoryEntry[] }>('/agent/company-directory')
      setEntries(res.entries)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch directory')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refetch()
  }, [refetch])

  return { entries, loading, error, refetch }
}
